<template><ListFilter field="system" :options="opts" label="Система" @filter="$emit('filter',$event)" @openDetail="$emit('openDetail',$event)"/></template>
<script>
import ListFilter from './ListFilter.vue'
export default { name:'SystemFilter', components:{ListFilter}, data(){ return { opts:['Система 1','Система 2','Система 3','Система 4','Система 5'] } } }
</script>
